var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.symbol.match-all.js
// module id = ZfDs
// module chunks = 0 1 2 3 4 5